import React from "react";
import styles from "./ParallelogramImage.module.scss";
import Image from "next/future/image";
import { Col, Container } from "react-bootstrap";
export default function ParallelogramImage({ backgroundPath, imageMeta }) {
  return (
    <Container>
      <Col lg={6} xs={12}>
        <div className="img-wrapper">
          <Image
            src={backgroundPath}
            alt={imageMeta || "ParallelogramImage"}
            className="img"
            priority={true}
            width={1920}
            height={1080}
          />
        </div>
      </Col>
    </Container>
  );
}
